//
// locales/vanilla/zh-HK.js
// automatically generated by generateLocalePacks.js
//

import messages from '../../../app/javascript/mastodon/locales/zh-HK.json';
import localeData from 'react-intl/locale-data/zh.js';
import { setLocale } from 'locales';

setLocale({
  localeData,
  messages,
});
